import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";

const Culet = () => {
  const culetRange = [
    { label: "A", value: "A" },
    { label: "Long", value: "Long" },
    { label: "N", value: "N" },
    { label: "VS", value: "VS" },
    { label: "S", value: "S" },
    { label: "M", value: "M" },
    { label: "SL", value: "SL" },
    { label: "L", value: "L" },
    { label: "VL", value: "VL" },
    { label: "XL", value: "XL" },
    { label: "P", value: "P" },
  ];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "culet", value: value }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "culet", value: value }));
  };
  return (
    <div className="w-100">
      <label className="filter-main-label">Culet</label>
      <div className="filter-bg-container culet-range range-outer-container">
        {culetRange.map((item) => {
          return (
            <div
              className={`range-item ${
                filterSelect?.culet?.includes(item?.value) ? "active" : ""
              }`}
              onClick={() =>
                filterSelect?.culet?.includes(item?.value)
                  ? handleRemoveFilter(item?.value)
                  : handleAddFilter(item?.value)
              }
            >
              {item?.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Culet;
